
import { useNavigate } from 'react-router-dom';
import { getMediaURL, formatDate } from '../../utils/helpers';
import { URL_ENDPOINTS } from '../../config/constants';
import { toTurkishDate } from '../../utils/dateConvertToTr'

const MagazineCard = ({ magazine }) => {
    const navigate = useNavigate();
    const imageUrl = getMediaURL(magazine.image) || '/placeholder_hor.jpg';

    const handleClick = () => {
        navigate(`/${URL_ENDPOINTS.MAGAZINES}/${magazine.slug}`);
    };

    const getPlainTextDescription = (markdown, maxLength = 150) => {
        if (!markdown) return '';

        let plainText = markdown
            .replace(/[#*`~_\[\]()]/g, '')
            .replace(/!\[.*?\]\(.*?\)/g, '')
            .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
            .replace(/^[-*+]\s+/gm, '')
            .replace(/^\d+\.\s+/gm, '')
            .replace(/\n+/g, ' ')
            .trim();

        return plainText.length > maxLength
            ? plainText.substring(0, maxLength).trim() + '...'
            : plainText;
    };

    return (
        <div
            className="group border border-gray-200 rounded-xl overflow-hidden mb-4 transition-all duration-300 cursor-pointer bg-white hover:shadow-xl hover:-translate-y-0.5 md:mb-5"
            onClick={handleClick}
        >
            {imageUrl && (
                <div className="relative overflow-hidden aspect-[16/9]">
                    <img
                        src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
                        alt={magazine.title}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                </div>
            )}

            <div className="p-5 flex flex-col h-[180px]">

                {/* Title (never shrinks) */}
                <h3 className="text-lg font-bold mb-2 text-gray-900 line-clamp-2 shrink-0 group-hover:text-blue-600 transition-colors">
                    {magazine.title}
                </h3>

                {/* Description wrapper (can shrink, prevents overflow into date) */}
                <div className="flex-grow min-h-0 pb-2 overflow-hidden">
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-2 md:line-clamp-3 overflow-hidden">
                        {getPlainTextDescription(magazine.description, 150)}
                    </p>
                </div>

                {/* Date (always visible, fixed space) */}
                {magazine.publishedAt && (
                    <p className="text-xs text-gray-400 pt-3 mt-auto border-t border-gray-100 h-[28px] shrink-0 bg-white relative z-10">
                        {toTurkishDate(magazine.publishedAt)}
                    </p>
                )}
            </div>
        </div>
    );
};

export default MagazineCard;
